// extracted by mini-css-extract-plugin
export default {"areaReports":"index_areaReports_gwnfm clearfix","leftwrap":"index_leftwrap_SPnbX","rightWrap":"index_rightWrap_krrXo"};